'use strict';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @typedef {Object} FormatResult
 * @property {boolean} useHooks
 * @property {Array} args
 */
/**
 *
 * @param {boolean} isInstance class or instance
 * @param {string} fnName
 * @param {array} args
 * @param {Bone} target class or instance
 * @returns {FormatResult} result
 * }
 */
function formatArgs(isInstance, fnName, args, target) {
    var useHooks = true;
    var opts;
    var argsRes;
    switch (fnName) {
        case 'create': {
            if (isInstance) {
                // instance.create()
                opts = args[0];
                if (opts && opts.hooks === false)
                    useHooks = false;
                argsRes = __spreadArray([target], __read(args), false);
                break;
            }
            break;
        }
        case 'update':
        case 'remove': {
            if (isInstance || (target.sequelize && isInstance)) {
                // instance.update(opts) instance.remove(forceUpdate)
                // class.update(values = {}, options) (sequelize mode only)
                opts = args[1];
                if (opts && opts.hooks === false)
                    useHooks = false;
                argsRes = __spreadArray([target], __read(args), false);
                break;
            }
            // class.update(conditions, values = {}, options) class.remove(conditions, forceDelete, options)
            opts = args[2];
            if (opts && opts.hooks === false)
                useHooks = false;
            argsRes = args;
            break;
        }
        case 'upsert': {
            if (target.sequelize) {
                // sequelize class.upsert(values, options);
                opts = args[2];
                argsRes = args;
            }
            else {
                // instance.upsert()
                opts = args[0];
                argsRes = __spreadArray([target], __read(args), false);
            }
            if (opts && opts.hooks === false)
                useHooks = false;
            break;
        }
        // sequelize mode instance only
        case 'destroy': {
            // instance.destroy(options)
            argsRes = __spreadArray([target], __read(args), false);
            opts = args[0];
            if (opts && opts.hooks === false)
                useHooks = false;
            break;
        }
        // sequelize mode only
        case 'bulkDestroy': {
            argsRes = args; // class.destroy
            opts = args[0];
            if (opts && opts.hooks === false)
                useHooks = false;
            break;
        }
        // bulkUpdate: sequelize mode only; bulkCreate: Bone and sequelize mode
        case 'bulkUpdate':
        case 'bulkCreate': {
            argsRes = args; // class.update class.bulkCreate
            opts = args[1];
            if (opts && opts.hooks === false)
                useHooks = false;
            break;
        }
        case 'save': {
            // instance.save()
            opts = args[0];
            if (opts && opts.hooks === false)
                useHooks = false;
            argsRes = __spreadArray([target], __read(args), false);
            break;
        }
    }
    return {
        useHooks: useHooks,
        args: argsRes,
    };
}
function getFnType(hookName) {
    var res = hookName.split(/([A-Z]\w+$)/);
    return {
        type: res[0],
        method: res[1].replace(res[1][0], res[1][0].toLowerCase()),
    };
}
// save equals to update|create|upsert
// bulkDestroy equals to class.destroy()
// bulkUpdate equals to class.update()
var hookableMethods = ['update', 'create', 'destroy', 'upsert', 'remove', 'save', 'bulkDestroy', 'bulkUpdate', 'bulkCreate'];
var hookType = {
    BEFORE: 'before',
    AFTER: 'after',
};
var hookNames = hookableMethods.reduce(function (result, method) {
    var e_1, _a;
    try {
        for (var _b = __values(Object.values(hookType)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var prefix = _c.value;
            result.push(prefix + method[0].toUpperCase() + method.slice(1));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
}, []);
function addHook(target, hookName, func) {
    var _a = getFnType(hookName), type = _a.type, method = _a.method;
    var sequelize = target.sequelize;
    if (hookableMethods.includes(method)) {
        // instance func
        var instanceOriginFunc_1 = target.prototype[method];
        target.prototype[method] = function () {
            return __awaiter(this, arguments, void 0, function () {
                var _a, useHooks, args, values, fields, originalRaw_1, changeRaw_1, name_1, res;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = formatArgs(true, method, arguments, this), useHooks = _a.useHooks, args = _a.args;
                            if (!(useHooks && type === hookType.BEFORE)) return [3 /*break*/, 4];
                            if (!(method === 'update' && typeof arguments[0] === 'object' && !arguments[0] != null)) return [3 /*break*/, 2];
                            values = arguments[0];
                            fields = arguments[1] && arguments[1].fields && arguments[1].fields.length ? arguments[1].fields : [];
                            originalRaw_1 = {};
                            changeRaw_1 = {};
                            for (name_1 in values) {
                                if ((!fields.length || fields.includes(name_1)) && this.hasAttribute(name_1)) {
                                    originalRaw_1[name_1] = this.attribute(name_1);
                                    this[name_1] = values[name_1];
                                    changeRaw_1[name_1] = this.attribute(name_1);
                                }
                            }
                            return [4 /*yield*/, func.apply(this, args)];
                        case 1:
                            _b.sent();
                            // revert instance after before hooks
                            Object.keys(originalRaw_1).forEach(function (key) {
                                var current = _this.attribute(key);
                                // raw[key] may changed in beforeUpdate hooks
                                if (current !== originalRaw_1[key] && current !== changeRaw_1[key])
                                    return;
                                _this.attribute(key, originalRaw_1[key]);
                            });
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, func.apply(this, args)];
                        case 3:
                            _b.sent();
                            _b.label = 4;
                        case 4: return [4 /*yield*/, instanceOriginFunc_1.call.apply(instanceOriginFunc_1, __spreadArray([this], __read(arguments), false))];
                        case 5:
                            res = _b.sent();
                            if (!(useHooks && type === hookType.AFTER)) return [3 /*break*/, 7];
                            return [4 /*yield*/, func.call(this, this, res)];
                        case 6:
                            _b.sent();
                            _b.label = 7;
                        case 7: return [2 /*return*/, res];
                    }
                });
            });
        };
        // class static method
        /**
         * 1、static create proxy to instance.create
         * 2、destroy(sequelize mode only) use instance hooks and bulkDestroy
         * 3、update in sequelize mode, use instance hooks and bulkUpdate
         */
        if (method === 'create' || method === 'destroy' || (sequelize && method === 'update'))
            return;
        var classOriginMethod_1 = target[method];
        target[method] = function () {
            return __awaiter(this, arguments, void 0, function () {
                var _a, useHooks, args, res;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = formatArgs(false, method, arguments, this), useHooks = _a.useHooks, args = _a.args;
                            if (!(useHooks && type === hookType.BEFORE)) return [3 /*break*/, 2];
                            return [4 /*yield*/, func.apply(this, args)];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2: return [4 /*yield*/, classOriginMethod_1.call.apply(classOriginMethod_1, __spreadArray([this], __read(arguments), false))];
                        case 3:
                            res = _b.sent();
                            if (!(useHooks && type === hookType.AFTER)) return [3 /*break*/, 5];
                            return [4 /*yield*/, func.call(this, res, this)];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5: return [2 /*return*/, res];
                    }
                });
            });
        };
    }
}
/**
 * setup hook to class
 * @param {Bone} target target class
 * @param {string} hookName
 * @param {function} func
 */
function setupSingleHook(target, hookName, func) {
    var method = getFnType(hookName).method;
    if (hookableMethods.includes(method)) {
        addHook(target, hookName, func);
    }
}
module.exports = {
    setupSingleHook: setupSingleHook,
    hookNames: hookNames,
};
//# sourceMappingURL=setup_hooks.js.map